module.exports = __webpack_public_path__ + "img/collar length.99b42a7d.png";